import { useEffect, useState } from 'react';

// Shows ambient text when signing in late at night (10pm–6am)
export function useLateNightEasterEgg() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const hour = new Date().getHours();
        const isLateNight = hour >= 22 || hour < 6;

        if (!isLateNight) return;

        const timer = setTimeout(() => setShow(true), 2000);
        return () => clearTimeout(timer);
    }, []);

    return show;
}
